import { createContext, useContext } from "react";
import { useBackendEngineState } from "./backendStore";

const EngineContext = createContext(null);

// Le moteur Projets (Espace Partenaire / Entreprise / Client) est toujours servi par le backend réel :
// aucun moteur DEMO local ne doit exister, pour garantir zéro donnée fictive dans ces espaces.
export const EngineProvider = ({ children }) => {
  const api = useBackendEngineState();
  return <EngineContext.Provider value={api}>{children}</EngineContext.Provider>;
};

export const useEngine = () => useContext(EngineContext);
